import { Link } from "react-router-dom";
import { Star } from "lucide-react";
import SiteLayout from "@/components/layout/SiteLayout";
import PageHero from "@/components/sections/PageHero";
import ContentSection from "@/components/sections/ContentSection";

const SuccessStories = () => (
  <SiteLayout>
    <PageHero title="Success Stories" subtitle="Real stories from clients who trusted Hadassah Homes with their real estate journey." />
    <ContentSection>
      <div className="text-center max-w-xl mx-auto py-8">
        <Star className="w-10 h-10 text-accent mx-auto mb-6" strokeWidth={1.5} />
        <h2 className="font-headline text-2xl text-foreground mb-4">Stories Coming Soon</h2>
        <p className="text-muted-foreground text-sm md:text-base leading-relaxed mb-8">
          We're gathering stories from clients who've successfully bought, sold, and invested with Hadassah Homes. Their experiences will be shared here soon.
        </p>
        <Link
          to="/consultation"
          className="inline-block font-body text-sm uppercase tracking-widest text-accent hover:text-accent/80 transition-colors"
        >
          Start Your Story →
        </Link>
      </div>
    </ContentSection>
  </SiteLayout>
);

export default SuccessStories;
